module.exports = __webpack_public_path__ + "static/companionship-93e5756d800183edb1bb207b431be000.png";